import { render, staticRenderFns } from "./OpcaoEntrega.vue?vue&type=template&id=13d7f853&scoped=true"
import script from "./OpcaoEntrega.vue?vue&type=script&lang=js"
export * from "./OpcaoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7f853",
  null
  
)

export default component.exports